<main class="about grid lg:grid-cols-2 w-full min-h-screen relative">
  <div class="fixed top-0 left-0 w-full lg:w-1/2 h-screen z-0">
    <img
      src="../../../assets/images/julio_graffin.png"
      alt="Julio Cezar Ferreira"
      class="w-full h-full object-cover object-top"
    />
  </div>

  <div
    class="lg:col-start-2 w-full lg:max-w-188 mt-130! lg:mt-0! lg:pt-80! pl-4! lg:pl-12! pr-4! lg:pr-12! pb-40! flex flex-col z-10 bg-(--color-secondary)!"
  >
    <h1 class="font-geograph-black mb-8! block! text-[30px]! pt-8!">
      {{ translate.translations().about.pageTitle }}
      <br />
      <span
        class="font-geograph-regular font-normal block mt-4 uppercase! leading-6! pt-4! tracking-[3px]!"
      >
        {{ translate.translations().about.pageSubtitle }}
      </span>
    </h1>

    <h2
      class="text-[20px] font-geograph-black text-(--color-accent) uppercase mb-5!"
    >
      {{ translate.translations().about.whoIAmTitle }}
    </h2>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case"
      [innerHTML]="translate.translations().about.whoIAmP1"
    ></p>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case"
      [innerHTML]="translate.translations().about.whoIAmP2"
    ></p>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case"
      [innerHTML]="translate.translations().about.whoIAmP3"
    ></p>

    <h2
      class="text-[18px] font-geograph-black text-(--color-accent) uppercase mb-5! mt-10! flex gap-4"
    >
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7083 2.41675L3.625 16.9167H14.5L13.2917 26.5834L25.375 12.0834H14.5L15.7083 2.41675Z"
          stroke="#DAE62C"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ translate.translations().about.experiencesTitle }}
    </h2>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case pl-11!"
      [innerHTML]="translate.translations().about.experienceAliensDesign"
    ></p>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case pl-11!"
      [innerHTML]="translate.translations().about.experienceSabion"
    ></p>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case pl-11!"
      [innerHTML]="translate.translations().about.experienceObjective"
    ></p>

    <h2
      class="text-[18px] font-geograph-black text-(--color-accent) uppercase mb-5! mt-10! flex gap-4"
    >
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.4168 14.3117V15.5C28.4152 18.2854 27.5133 20.9956 25.8456 23.2265C24.1778 25.4574 21.8336 27.0894 19.1625 27.8792C16.4914 28.6689 13.6366 28.5741 11.0239 27.6088C8.41108 26.6435 6.18034 24.8595 4.66432 22.5229C3.1483 20.1862 2.42823 17.4221 2.6115 14.6427C2.79476 11.8634 3.87156 9.21774 5.68127 7.10037C7.49099 4.983 9.93668 3.50736 12.6536 2.89351C15.3705 2.27966 18.213 2.56051 20.7573 3.69415M28.4168 5.16665L15.5002 18.0962L11.6252 14.2212"
          stroke="#DAE62C"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ translate.translations().about.whatIBringTitle }}
    </h2>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case pl-11!"
      [innerHTML]="translate.translations().about.whatIBringP1"
    ></p>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case pl-11!"
      [innerHTML]="translate.translations().about.whatIBringP2"
    ></p>
    <p
      class="text-[16px] leading-8! text-(--color-light) normal-case pl-11!"
      [innerHTML]="translate.translations().about.whatIBringP3"
    ></p>

    <h2 class="text-[23px] text-(--color-accent) uppercase mb-5! mt-20! pl-11!">
      {{ translate.translations().about.cta }}
    </h2>
  </div>
</main>
